import * as React from 'react';
import { ChangePassword } from './change-password';
import { maxDbUserPasswordLength } from 'app/area/administration/edit/constants';

export interface ChangeDatabaseAccountProps {
  personId: string;
  title: string;
  textInfo?: string;
  translation: any;
  validation: any;
  fetching: boolean;
  clearValidation: (fieldName: string) => void;
  onSave: (password: string) => void;
  onClose: () => void;
}

export const ChangeDatabaseAccount = (props: ChangeDatabaseAccountProps) => {
  return <ChangePassword
    onClose={props.onClose}
    setPassword={props.onSave}
    validation={props.validation.password}
    clearValidation={props.clearValidation}
    textTitle={props.title}
    textPassword={props.translation.password}
    textConfirmPassword={props.translation.confirm_password}
    textDoneButton={props.translation.create}
    textCancel={props.translation.cancel}
    textMustBeEqual={props.translation.must_be_equal}
    textPasswordHint={props.translation.password_policy_db_account}
    textInfo={props.textInfo}
    fetching={props.fetching}
    maxLength={maxDbUserPasswordLength} />;
};
